import { errorMessages } from '../handlers/page';

module.exports = {
  _onSavedCheckOnce: function () {
    return this.appBridge.version.isApp('webrand') || this.appBridge.version.isApp('pdf') ||
      (!window.Android && !this.appBridge.version.isLowerThan('2.2.1')) ||
      (window.Android && !this.appBridge.version.isLowerThan('2.1'));
  },

  _onSaved: async function (deferred, result, errorType) {
    const isOffline = navigator.onLine === false;

    try {
      if (result) {
        await INKIVE.PageFactory.propagateStateChanges();
        this.trigger('saved');
        INKIVE.hasEditorUnsavedChanges = false;
        deferred.resolve();
      } else {
        INKIVE.Modal.togglePageLoader(false);

        const message = isOffline ? errorMessages.offline : errorMessages.saveFailed;

        deferred.reject(new Error(message));
        this.trigger(errorType === 'Forbidden' ? '403' : 'saving.error', { error: errorType });
      }
    } catch (error) {
      const message = isOffline ? errorMessages.offline : errorMessages.userNotFound;

      deferred.reject(new Error(message));
      this.trigger('saving.error', { error: message });
    }
  }
};
